"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingUpdateValue = exports.PricingUpdateType = exports.BulkUpdateEntityType = void 0;
var BulkUpdateEntityType;
(function (BulkUpdateEntityType) {
    BulkUpdateEntityType["REPLACE"] = "REPLACE";
    BulkUpdateEntityType["EXTEND"] = "EXTEND";
})(BulkUpdateEntityType = exports.BulkUpdateEntityType || (exports.BulkUpdateEntityType = {}));
var PricingUpdateType;
(function (PricingUpdateType) {
    PricingUpdateType["SET_AMOUNT"] = "SET_AMOUNT";
    PricingUpdateType["MODIFY"] = "MODIFY";
})(PricingUpdateType = exports.PricingUpdateType || (exports.PricingUpdateType = {}));
var PricingUpdateValue;
(function (PricingUpdateValue) {
    PricingUpdateValue["INCREASE_BY_FLAT_AMOUNT"] = "INCREASE_BY_FLAT_AMOUNT";
    PricingUpdateValue["INCREASE_BY_PERCENTAGE"] = "INCREASE_BY_PERCENTAGE";
    PricingUpdateValue["DECREASED_BY_PERCENTAGE"] = "DECREASED_BY_PERCENTAGE";
    PricingUpdateValue["DECREASED_BY_FLAT_AMOUNT"] = "DECREASED_BY_FLAT_AMOUNT";
})(PricingUpdateValue = exports.PricingUpdateValue || (exports.PricingUpdateValue = {}));
//# sourceMappingURL=bulkOperation.js.map